import { useGetTaskCaptchaQuery } from "features/adminUsers/adminUsers";

import CaptchaSolveDialog from "./CaptchaSolveDialog";

type Props = {
  taskId: number | null;
  submitting: boolean;
  error: string | null;
  canEdit: boolean;
  onSubmit: (clicks: number[][], taskType: string) => void;
  onClose: () => void;
};

/**
 * Loads the challenge for one task and hands it to the dialog.
 *
 * Polls slowly while open: the socket delivers each new round, and this is the
 * fallback for when it is not - Paycom serves challenges in series and a missed
 * one stalls the bot until its request expires.
 */
export default function TaskCaptchaDialog({
  taskId,
  submitting,
  error,
  canEdit,
  onSubmit,
  onClose,
}: Props) {
  const { data } = useGetTaskCaptchaQuery(taskId as number, {
    skip: taskId == null,
    pollingInterval: taskId == null ? 0 : 5000,
  });

  return (
    <CaptchaSolveDialog
      open={taskId != null}
      challenge={data ?? null}
      submitting={submitting}
      error={error}
      canSubmit={canEdit}
      onSubmit={onSubmit}
      onClose={onClose}
    />
  );
}
